import { render } from "./ModalLink.vue?vue&type=template&id=280f71ce&scoped=true"
import script from "./ModalLink.vue?vue&type=script&lang=js"
export * from "./ModalLink.vue?vue&type=script&lang=js"

import "./ModalLink.vue?vue&type=style&index=0&id=280f71ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280f71ce"]])

export default __exports__